import React, { useState, useEffect } from "react";
import { Empty, Select, Form, Input, InputNumber } from 'antd';
import { baseURLs } from '../../../utils/Constants';
import axios from 'axios';
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from 'moment';
import { getAxiosHeaders, getQueryParams } from "../../../utils/Utils";
import { Alert, 
  Badge, 
  DropdownToggle, 
  DropdownMenu, 
  Card, 
  UncontrolledDropdown, 
  DropdownItem, 
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner } from "reactstrap";
import {
  Block,
  Icon,
  Button,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
} from "../../../components/Component";
import {
  AlertModal,
  SuccessModal,
  LoadingModal
} from "../AlertModals";
import { TableLoader } from "../../../utils/Loaders";
import { PaginationWithOnclick } from "./Pagination";

export const DamagesLossTable = ({ history, businessID, currency, ...props }) => {
  const [tableData, setTableData] = useState({meta: {total_records: 0, total_amount_damaged: 0, total_amount_loss: 0}, damages:[]});
  const [loading, setLoading] = useState(true);
  const [requesting, setRequesting] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [hasFilters, setHasFilters] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [checkedBoxes, setCheckedBoxes] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [issueDate, setIssueDate] = useState(new Date());
  const [issueDateTime, setIssueDateTime] = useState(new Date());
  const [filters, setFilters] = useState({
    business: businessID,
    page: 1,
    item_search: '',
    source_type: 'all',
    type: 'all',
    date_range: null,
    dateRangeStart: null,
    dateRangeEnd: null,
  });
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    damaged_id: '',
    item_name: '',
    quantity: '',
    cost_price: '',
    source_type: '',
    type: '',
    date: '',
    date_time: '',
  });
  const [downloadLink, setDownloadLink] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeModal, setActiveModal] = useState(null);
 
  const toggleModal = (modal) => {
    if (activeModal === modal) {
      setActiveModal(null);
    } else {
      setActiveModal(modal);
    }
  };

  const onInputChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const onDateChange = (date, type) => {
    let params = filters;

    if(!moment(date).isValid()){
      params.date_range = null;
      params.dateRangeStart = null;
      params.dateRangeEnd = null;
      setFilters({...params});
      return;
    }

    if(type === 'from') {
      params.dateRangeStart = date;  
      setFromDate(date);  
    } else {
      params.dateRangeEnd = date;
      setToDate(date);  
    }

    if(moment(params.dateRangeStart).isValid() && moment(params.dateRangeEnd).isValid()) {
      params.date_range = `${moment(params.dateRangeStart).format("YYYY-MM-DD")},${moment(params.dateRangeEnd).format("YYYY-MM-DD")}`;
      setFilters({...params});      
    }
  }

  const onSelectChange = (value, name) => {
    setFilters({ ...filters, [name]: value });
  };

  const selectAll = () => {
    setCheckAll(prevCheckAll => {
      if (prevCheckAll) {
        setCheckedBoxes([]);
      } else {
        const allIDs = tableData.damages.map(item => item.damaged_id);
        setCheckedBoxes(allIDs);
      }
      return !prevCheckAll;
    });
  }

  const handleCheckboxChange = (value) => {
    setCheckedBoxes(prevBoxes => {
      if (prevBoxes.includes(value)) {
          return prevBoxes.filter(id => id !== value);
      } else {
          return [...prevBoxes, value];
      }
    });
    if (checkAll) {
        setCheckAll(false);
    }
  };

  const currentUrl = (filters) => {
    let item_search = filters.item_search.length > 0 ? `&i=${filters.item_search}` : ``;
    let source_type = filters.source_type !== null ? `&s=${filters.source_type}` : ``;
    let type = filters.type !== null ? `&t=${filters.type}` : ``;
    let date_range = filters.date_range !== null ? `&r=${filters.date_range}` : ``;
    
    if( (item_search !== '' || filters.source_type !== 'all' ||
    filters.type !== 'all' || date_range !== '' ) && !hasFilters) {
      setHasFilters(true)
    }

    let params = `${item_search}${source_type}${type}${date_range}`;
    let url = `${process.env.PUBLIC_URL}${window.location.pathname}?p=${filters.page}${params}`;
    history.replace(url);
  }

  const loadNextPage = (page) => {
    let params = filters;
    params.page = page;
    setFilters({...params});
    getDamages(params)
  }

  const resetFilter = () => {
    let params = {
      business: businessID,
      page: 1,
      item_search: '',
      source_type: 'all',
      type: 'all',
      date_range: null,
      dateRangeStart: null,
      dateRangeEnd: null,
    };
  
    toggleModal('filterModal');
    setHasFilters(false);
    setFromDate(null);
    setToDate(null);
    setFilters({ ...params });
    getDamages(params);
  }

  const filterDamages = () => {
    toggleModal('filterModal');
    setHasFilters(true);
    let params = filters;
    params.page = 1;
    setFilters({...params});
    getDamages(filters);
  }

  const getDamages = (filters) => {
    setLoading(true);

    axios.get(baseURLs.API_URL + "/damages", {
      params: {
        business_id: businessID,
        page: filters.page,
        item_name: filters.item_search,
        item_source: filters.source_type,
        type: filters.type,
        date_from: !moment(filters.dateRangeStart).isValid() ? null : moment(filters.dateRangeStart).format("YYYY-MM-DD"),
        date_to: !moment(filters.dateRangeEnd).isValid() ? null : moment(filters.dateRangeEnd).format("YYYY-MM-DD"),
      },
      headers: getAxiosHeaders().headers
    })
    .then((response) => {
      if (response.status === 204) {
        setTotalPages(0);
        setTableData({meta: {total_records: 0, total_amount_damaged: 0, total_amount_loss: 0}, damages:[]});
      } else {
        let responseInfo = response.data;
        setTotalPages(Math.ceil(responseInfo.data.meta.total_records / 10));
        setTableData(responseInfo.data);
      }

      setLoading(false);
      currentUrl(filters);
    }).catch((error) => {
      try{
        let errorResponse = error.response.data;

        if(error.response.status === 401){
          history.push(`${process.env.PUBLIC_URL}/expired-session`);
          return;
        }

        if(error.response.status === 404){
          history.push(`${process.env.PUBLIC_URL}/not-found`);
          return;
        }

        if(error.response.status === 403){
          history.push(`${process.env.PUBLIC_URL}/unauthorized/b/${businessID}`);
          return;
        }

        if(error.response.status === 402){
          history.push(`${process.env.PUBLIC_URL}/subscription/b/${businessID}`);
          return;
        }

        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setTotalPages(0);
        setTableData({meta: {total_records: 0, total_amount_damaged: 0, total_amount_loss: 0}, damages:[]});

        setLoading(false);
        setErrorMessage(errorMessage);
      }catch(e){
        console.log(e);
        // history.push(`${process.env.PUBLIC_URL}/server-offline`);
      }
    });
  }

  const deleteDamagesByIDs = () => {
    toggleModal('deleteLoadingModal');

    axios.delete(baseURLs.API_URL + "/damages/by-ids", {
      headers: getAxiosHeaders().headers,
      data: {
        business_id: businessID,
        items: JSON.stringify(checkedBoxes),
      }
    })
    .then((response) => {
      let responseInfo = response.data;
      let successfulIDs = responseInfo.data.successful_ids;
      let failedIDs = responseInfo.data.failed_ids;

      if(successfulIDs.length > 0 && failedIDs.length === 0){
        getDamages(filters);
        toggleModal('successDeleteModal');

      } else if(successfulIDs.length > 0 && failedIDs.length > 0) {
        getDamages(filters);
        setErrorMessage(`${successfulIDs.length} ${successfulIDs.length > 1 ? `items` : `item`} were successfully deleted and ${failedIDs.length} ${failedIDs.length > 1 ? `items` : `item`} failed to get deleted`);
        toggleModal('deleteErrorModal');

      } else {
        setErrorMessage(`Error deleting ${failedIDs.length > 1 ? `items` : `item`}. The selected ${failedIDs.length > 1 ? `items were` : `item was`} not found.`);
        toggleModal('deleteErrorModal');
      }

      setCheckedBoxes([]);
      setCheckAll(false);
    }).catch((error) => {
      try{
        let errorResponse = error.response.data;

        if(error.response.status === 401){
          history.push(`${process.env.PUBLIC_URL}/expired-session`);
          return;
        }

        if(error.response.status === 404){
          history.push(`${process.env.PUBLIC_URL}/not-found`);
          return;
        }

        if(error.response.status === 403){
          history.push(`${process.env.PUBLIC_URL}/unauthorized/b/${businessID}`);
          return;
        }

        if(error.response.status === 402){
          history.push(`${process.env.PUBLIC_URL}/subscription/b/${businessID}`);
          return;
        }

        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setErrorMessage(errorMessage);
        toggleModal('deleteErrorModal');
      }catch(e){
        console.log(e);
        // history.push(`${process.env.PUBLIC_URL}/server-offline`);
      }
    });
  }

  const deleteDamagesByFilter = () => {
    toggleModal('deleteLoadingModal');

    axios.delete(baseURLs.API_URL + "/damages/by-filters", {
      headers: getAxiosHeaders().headers,
      data: {
        business_id: businessID,
        item_name: filters.item_search,
        item_source: filters.source_type,
        type: filters.type,
        date_from: !moment(filters.dateRangeStart).isValid() ? null : moment(filters.dateRangeStart).format("YYYY-MM-DD"),
        date_to: !moment(filters.dateRangeEnd).isValid() ? null : moment(filters.dateRangeEnd).format("YYYY-MM-DD"),
      }
    })
    .then((response) => {
      getDamages(filters);
      toggleModal('successDeleteModal');
      setCheckAll(false);
    }).catch((error) => {
      try{
        let errorResponse = error.response.data;

        if(error.response.status === 401){
          history.push(`${process.env.PUBLIC_URL}/expired-session`);
          return;
        }

        if(error.response.status === 404){
          history.push(`${process.env.PUBLIC_URL}/not-found`);
          return;
        }

        if(error.response.status === 403){
          history.push(`${process.env.PUBLIC_URL}/unauthorized/b/${businessID}`);
          return;
        }

        if(error.response.status === 402){
          history.push(`${process.env.PUBLIC_URL}/subscription/b/${businessID}`);
          return;
        }

        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setErrorMessage(errorMessage);
        toggleModal('deleteErrorModal');
      }catch(e){
        console.log(e);
        // history.push(`${process.env.PUBLIC_URL}/server-offline`);
      }
    });
  }

  const handleSelectedRecordsAction = (action) => {
    if(!checkAll && checkedBoxes.length === 0){
      toggleModal('noSelectionAlertModal');
      return;
    }

    toggleModal('deleteAlertModal');    
  }

  const handleSingleDelete = (damagedID) => {
    setCheckedBoxes([damagedID]);

    setTimeout(() => {
      toggleModal('deleteAlertModal');       
    }, 500);
  }

  const downloadDamages = () => {
    setErrorMessage("");
    toggleModal('loadingModal');
    
    axios.get(baseURLs.API_URL + "/damages/download", {
      params: {
        business_id: businessID,
        item_name: filters.item_search,
        item_source: filters.source_type,
        type: filters.type,
        date_from: !moment(filters.dateRangeStart).isValid() ? null : moment(filters.dateRangeStart).format("YYYY-MM-DD"),
        date_to: !moment(filters.dateRangeEnd).isValid() ? null : moment(filters.dateRangeEnd).format("YYYY-MM-DD"),
      },
      headers: getAxiosHeaders().headers
    })
    .then((response) => {
      if (response.status === 204) {
        setErrorMessage('No items found');        
        toggleModal('alertModal');
      } else {
        let responseInfo = response.data;
        setDownloadLink(responseInfo.data.download_link);
        toggleModal('downloadModal');
      }

    }).catch((error) => {
      try{
        let errorResponse = error.response.data;

        if(error.response.status === 401){
          history.push(`${process.env.PUBLIC_URL}/expired-session`);
          return;
        }

        if(error.response.status === 404){
          history.push(`${process.env.PUBLIC_URL}/not-found`);
          return;
        }

        if(error.response.status === 403){
          history.push(`${process.env.PUBLIC_URL}/unauthorized/b/${businessID}`);
          return;
        }

        if(error.response.status === 402){
          history.push(`${process.env.PUBLIC_URL}/subscription/b/${businessID}`);
          return;
        }

        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setErrorMessage(errorMessage);
        toggleModal('alertModal');

      }catch(e){
        console.log(e);
        // history.push(`${process.env.PUBLIC_URL}/server-offline`);
      }
    });
  }

  const handleEditFormSubmit = (_formData) => {
    setRequesting(true);
    setErrorMessage("");

    axios.put(baseURLs.API_URL + `/damages/${_formData.damaged_id}`, {
      business_id: businessID,
      type: _formData.type,
      quantity: _formData.quantity
    }, getAxiosHeaders())
    .then((response) => {
      form.resetFields();
      toggleModal("editSuccessModal");

      setRequesting(false);
      getDamages(filters);
    }).catch((error) => {
      try{
        let errorResponse = error.response.data;

        if(errorResponse.hasOwnProperty("errors")){
          form.setFields([
            {
              name: 'type',
              errors: errorResponse.errors.hasOwnProperty("type") ? [errorResponse.errors.type] : [],
            },
            {
              name: 'quantity',
              errors: errorResponse.errors.hasOwnProperty("quantity") ? [errorResponse.errors.quantity] : [],
            }
          ]);

        }


        let errorMessage = 'Error: Could not connect to server';
        if(errorResponse.hasOwnProperty("error")){
          errorMessage = errorResponse.error;
        }

        setErrorMessage(errorMessage);
        setRequesting(false);
      }catch(e){
        setErrorMessage("Error: Could not connect to server");
      }
    });
    
  }

  const onFinishFailed = (errorInfo) => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    console.log('Failed:', errorInfo);
  };

  const editItem = (item) => {
    setIssueDate(moment(item.dated).toDate());
    setIssueDateTime(moment(item.dated).toDate());

    setFormData({
      ...formData,
      damaged_id: item.damaged_id,
      item_name: item.item_name,
      quantity: item.quantity,
      cost_price: item.cost_price,
      source_type: item.source_type,
      type: item.type,
      date: moment(item.dated),
      date_time: moment(item.dated)
    })

    form.setFieldsValue({
      damaged_id: item.damaged_id,
      item_name: item.item_name,
      quantity: item.quantity,
      cost_price: item.cost_price,
      source_type: item.source_type,
      type: item.type,
      date: moment(item.dated),
      date_time: moment(item.dated)
    });

    toggleModal('editModal');
  }

  useEffect(() => {
    setLoading(true);
    let url_string = window.location.href;
    let url = new URL(url_string);
    let queryParams = getQueryParams(url);

    let page = queryParams.hasOwnProperty('p') ? queryParams.p : 1;
    let item_search = queryParams.hasOwnProperty('i') ? queryParams.i : '';
    let source_type = queryParams.hasOwnProperty('s') ? queryParams.s : 'all';
    let type = queryParams.hasOwnProperty('t') ? queryParams.t : 'all';
    let date_range = queryParams.hasOwnProperty('r') ? queryParams.r : null;
    let dateRangeStart = null;
    let dateRangeEnd = null;

    if(date_range !== null){
      let rangeSplit = date_range.split(',');
      dateRangeStart = new Date(rangeSplit[0]);
      dateRangeEnd = new Date(rangeSplit[1]);
      setFromDate(dateRangeStart);
      setToDate(dateRangeEnd);
    }

    let params = filters;
    params.page = page;
    params.item_search = item_search;
    params.source_type = source_type;
    params.type = type;
    params.date_range = date_range;
    params.dateRangeStart = dateRangeStart;
    params.dateRangeEnd = dateRangeEnd;

    setFilters(params)
    getDamages(params);
  }, []);

  
  return (
    <Block>
      {
        loading ?
        <div className="card-inner p-0">
          <TableLoader />
        </div>
        :
        <>
          {
            tableData.damages.length > 0 &&
            <div className="row g-gs mb-5">
              <div className="col-md-12">
                <Card className="card-bordered">
                  <div className="card-inner">
                    <div className="analytic-data-group analytic-ov-group g-3 justify-content-md-evenly ">
                      <div className="analytic-data text-md-center me-4">
                        <div className="title text-danger">Total Damages</div>
                        <div className="amount"><small className="text-muted fw-light">{currency}</small> {tableData.meta.total_amount_damaged}</div>
                      </div>
                      <div className="btn-toolbar-sep me-3 ms-3 d-none d-sm-inline"></div>
                      <div className="analytic-data text-md-center me-4">
                        <div className="title text-warning">Total Loss</div>
                        <div className="amount"><small className="text-muted fw-light">{currency}</small> {tableData.meta.total_amount_loss}</div>
                      </div>
                    </div>
                  </div>
                </Card>   
              </div>
            </div>
          }
          <Card className="card-bordered card-stretch">
            <div className="card-inner-group">
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title">
                    <h6 className="title">
                      {`${tableData.meta.total_records} ${tableData.meta.total_records > 1 ? `Items` : `Item`}`}
                    </h6>
                  </div>
                  <div className="card-tools me-n1">
                    <ul className="btn-toolbar">
                      <li>
                        <Button className="btn-icon btn-trigger" onClick={() => toggleModal('filterModal')} title="Filter">
                          { hasFilters && <div className="dot dot-primary"></div> }
                          <Icon name="search"></Icon>
                        </Button>
                        {
                          activeModal === "filterModal" &&
                          <Modal isOpen={true} toggle={() => toggleModal('filterModal')}>
                            <ModalHeader
                              toggle={() => toggleModal('filterModal')}
                              close={
                                <button className="close" onClick={() => toggleModal('filterModal')}>
                                  <Icon name="cross" />
                                </button>
                              }
                            >
                              Damages Filter
                            </ModalHeader>
                            <ModalBody>
                              <form>
                                <div className="form-group">
                                  <label className="form-label" htmlFor="item_search">
                                    Item Name
                                  </label>
                                  <div className="form-control-wrap">
                                    <input type="text" onChange={onInputChange} name="item_search" className="form-control form-control-lg" id="item_search" defaultValue={filters.item_search} />
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="form-label" htmlFor="source_type">
                                    Source Type
                                  </label>
                                  <div className="form-control-wrap">
                                  <Select size="large"                          
                                      placeholder="Select source type"
                                      defaultValue={filters.source_type}
                                      style={{ width: "100%" }} 
                                      name="source_type"
                                      onChange={(value) => onSelectChange(value, "source_type")}
                                      filterOption={(input, option) =>
                                        option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                      }
                                      options={[
                                        {value: "all", label: "All"},
                                        {value: "inventory", label: "Inventory"},
                                        {value: "raw_material", label: "Raw Materials"},
                                      ]} 
                                      showSearch /> 
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label className="form-label" htmlFor="type">
                                    Type
                                  </label>
                                  <div className="form-control-wrap">
                                  <Select size="large"                          
                                      placeholder="Select type"
                                      defaultValue={filters.type}
                                      style={{ width: "100%" }} 
                                      name="type"
                                      onChange={(value) => onSelectChange(value, "type")}
                                      filterOption={(input, option) =>
                                        option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                      }
                                      options={[
                                        {value: "all", label: "All"},
                                        {value: "damaged", label: "Damaged"},
                                        {value: "loss", label: "Loss"},
                                      ]} 
                                      showSearch /> 
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="form-label">From Date</label>                          
                                      <div className="form-control-wrap">
                                        <DatePicker
                                          selected={fromDate}
                                          dateFormat="dd-MMM-yyyy"
                                          onChange={date => {
                                            onDateChange(date, 'from');
                                          }}
                                          
                                          showMonthDropdown
                                          showYearDropdown
                                          isClearable
                                          className="form-control form-control-lg date-picker"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="form-label">To Date</label>                          
                                      <div className="form-control-wrap">
                                        <DatePicker
                                          selected={toDate}
                                          dateFormat="dd-MMM-yyyy"
                                          onChange={date => {
                                            onDateChange(date, 'to');
                                          }}
                                          
                                          showMonthDropdown
                                          showYearDropdown
                                          isClearable
                                          className="form-control form-control-lg date-picker"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </ModalBody>
                            <ModalFooter className="bg-lighter justify-content-center">
                              <Button color="primary" type="submit" onClick={(ev) => { ev.preventDefault(); filterDamages();} } size="lg">
                                Apply Filter
                              </Button>

                              {
                                hasFilters &&
                                <Button className="ms-3 text-muted" color="light" onClick={(ev) => { ev.preventDefault(); resetFilter();} } size="lg">
                                  Reset Filter
                                </Button>
                              }
                            </ModalFooter>
                          </Modal>
                        }
                      </li>
                      <li className="btn-toolbar-sep"></li>
                      <li>
                        <Button className="btn-icon btn-trigger" title="Reload" onClick={() => {getDamages(filters)}}>
                          <Icon name="redo"></Icon>
                        </Button>
                      </li>
                      <li className="btn-toolbar-sep"></li>
                      <li>
                        <Button className="btn-icon btn-trigger" onClick={downloadDamages} title="Download Damages">
                          <Icon name="download-cloud"></Icon>
                        </Button>
                        { activeModal === "loadingModal" && <LoadingModal showModal={true} headerText={"Preparing Damages and Loss"} descriptionText={"Please wait while your damages are being prepared for download."} /> }
                        
                        { 
                          activeModal === "downloadModal" &&
                          <SuccessModal showModal={true} toggleModal={() => toggleModal('downloadModal')}
                            headerText={"Damages Ready"} descriptionText={"Damages and Loss CSV is ready for download."} 
                            leftButtonText={"Download"} leftButtonOnClick={() => {window.open(downloadLink, '_blank').focus(); toggleModal('downloadModal');}}
                          />
                        }
                        
                        {
                          activeModal === "alertModal" &&
                          <AlertModal showModal={true} toggleModal={() => toggleModal('alertModal')}
                            headerText={"Download Failed"} descriptionText={errorMessage}                       
                          />
                        }
                      </li>
                    </ul>
                  </div>
                </div>
              </div>          
              <div className="card-inner p-0">
                {
                  tableData.damages.length === 0 ?
                  <div className="text-center m-5">
                    <div className="price-plan-media"><Empty image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" imageStyle={{height: 60}} description={false} /></div>
                    <div className="price-plan-info">
                      <h5 className="title fw-normal">No item found</h5><span>Record a damage or loss using the button below.</span>
                    </div>
                    <div className="price-plan-action">
                      <Link to={`${process.env.PUBLIC_URL}/damages-loss/b/${businessID}/add`}>
                        <button className="btn btn-outline-primary">Record Damages</button>
                      </Link>                    
                    </div>
                  </div>
                  :
                  <>      
                    <DataTableBody>
                      <DataTableHead className="bg-lighter fw-bold">
                        <DataTableRow className="nk-tb-col-check">
                          <div className="custom-control custom-control-sm custom-checkbox">
                            <input
                              type="checkbox"
                              checked={checkAll}
                              onChange={selectAll}
                              className="custom-control-input table-checkbox"
                              id="select_all" />
                            <label className="custom-control-label" htmlFor="select_all"/>
                          </div>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="sub-text">Item Name</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="sub-text">Issued By</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="sub-text">Quantity</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="sub-text">Total</span>
                        </DataTableRow>
                        <DataTableRow size="xl">
                          <span className="sub-text">Date</span>
                        </DataTableRow>
                        <DataTableRow className="nk-tb-col-tools text-end">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              tag="a"
                              className="text-soft dropdown-toggle btn btn-icon btn-trigger"
                            >
                              <Icon name="more-h"></Icon>
                            </DropdownToggle>
                            <DropdownMenu end>
                              <ul className="link-list-opt text-capitalize" style={{letterSpacing: "normal"}}>
                                <li>
                                  <DropdownItem tag="a" className="pointer-cursor text-danger" onClick={() => handleSelectedRecordsAction('cancel')}>
                                    <Icon name="trash"></Icon>
                                    <span>Delete Selected Items</span>
                                    {
                                      activeModal === "deleteAlertModal" &&
                                      <AlertModal showModal={true} toggleModal={() => toggleModal('deleteAlertModal')}
                                        headerText={checkedBoxes.length > 1 ? `Delete Items` : `Delete Item`} 
                                        descriptionText={`${checkAll ? 
                                        `Are you sure you want to delete all ${tableData.meta.total_records} items. This action can not be reverted.` 
                                        :
                                        `Are you sure you want to delete ${checkedBoxes.length > 1 ? `these ${checkedBoxes.length} selected items` : `this selected item`}. This action can not be reverted.`}`}
                                        leftButtonText={`Delete`}
                                        leftButtonOnClick={checkAll ? deleteDamagesByFilter : deleteDamagesByIDs} />
                                    }
                                  </DropdownItem>
                                </li>
                              </ul>
                              {
                                activeModal === "noSelectionAlertModal" &&
                                <AlertModal showModal={true} toggleModal={() => toggleModal('noSelectionAlertModal')}
                                  headerText={`Error`} 
                                  descriptionText={`No item has been selected. Select an item and try again.`}
                                />
                              }

                              { activeModal === "deleteLoadingModal" && <LoadingModal showModal={true} headerText={`Deleting...`} descriptionText={`Please wait while the ${checkedBoxes.length > 1 ? `items are` : `item is`} being deleted`} /> }
                        
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </DataTableRow>
                      </DataTableHead>
                      {
                        tableData.damages.map((data, index) => {
                          return (
                            <DataTableItem key={index}>
                              <DataTableRow className="nk-tb-col-check">
                                <div className="custom-control custom-control-sm custom-checkbox">
                                  <input
                                    type="checkbox"
                                    checked={checkAll || checkedBoxes.includes(data.damaged_id)}
                                    onChange={() => handleCheckboxChange(data.damaged_id)}
                                    className="custom-control-input table-checkbox"
                                    id={`item${data.damaged_id}`} 
                                  />
                                  <label className="custom-control-label" htmlFor={`item${data.damaged_id}`} />
                                </div>
                              </DataTableRow>
                              <DataTableRow>
                                <div className="user-card">
                                  <span className="me-1 text-muted align-baseline">{filters.page == 1 ? index + 1 : ((filters.page - 1) * 10) + (index + 1)}.</span>
                                  <div className="user-info">
                                    <div className="text-bold">{data.item_name}</div>
                                    <span className="text-muted" title="Source">Source: <b>{data.item_source}</b></span>  
                                    <span className="ms-2">
                                      {
                                        data.type === 'damaged' &&
                                        <Badge className="badge-dot me-2" color="danger">Damaged</Badge>
                                      }

                                      {
                                        data.type === 'lost' &&
                                        <Badge className="badge-dot me-2" color="warning">Lost</Badge>
                                      }
                                    </span>                                  
                                    <div className="price d-md-none">
                                      <span>
                                        <small>{currency} </small> {data.total_amount} • Qty: {data.quantity}
                                      </span>
                                      
                                    </div>
                                  </div>
                                </div>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <span>{data.issued_by}</span>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <span>{data.quantity}</span>
                              </DataTableRow>
                              <DataTableRow size="md">
                                <span className="tb-amount">
                                  <small className="text-muted">{currency} </small>{data.total_amount}
                                </span>
                              </DataTableRow>
                              <DataTableRow size="xl">
                                <span>{moment(data.dated).format("Do MMM YYYY")}</span>
                              </DataTableRow>
                              <DataTableRow className="nk-tb-col-tools text-end">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    className="text-soft dropdown-toggle btn btn-icon btn-trigger"
                                  >
                                    <Icon name="more-h"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    <ul className="link-list-opt no-bdr">
                                      <li>
                                        <DropdownItem tag="a" className="pointer-cursor" onClick={() => editItem(data)}>
                                          <Icon name="edit-alt"></Icon>
                                          <span>Edit</span>
                                        </DropdownItem>
                                      </li>
                                      <li className="divider"></li>
                                      <li>
                                        <DropdownItem tag="a" className="pointer-cursor text-danger" onClick={() => handleSingleDelete(data.damaged_id)}>
                                          <Icon name="trash"></Icon>
                                          <span>Delete</span>
                                        </DropdownItem>
                                      </li>
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </DataTableRow>
                            </DataTableItem>
                          )
                        })
                      }
                    </DataTableBody>   
                    <PaginationWithOnclick currentPage={filters.page} pageCount={totalPages} loadNextPage={loadNextPage} />                                       
                  </>
                }              
              </div>
            </div>
          </Card>
        </>
      }

      { 
        activeModal === "successDeleteModal" &&
        <SuccessModal showModal={true} toggleModal={() => toggleModal(null)}
          headerText={`Deleted`} descriptionText={`Item(s) deleted successfully.`} 
        />
      }
      
      {
        activeModal === "deleteErrorModal" &&
        <AlertModal showModal={true} toggleModal={() => toggleModal(null)}
          headerText={"Error"} descriptionText={errorMessage}                       
        />
      }

      {
        activeModal === "editModal" &&
        <Modal backdrop="static" isOpen={true} id="edit_damages_modal">
          <ModalHeader
            toggle={() => toggleModal('editModal')}
            close={
              <button className="close" disabled={requesting} onClick={() => toggleModal('editModal')}>
                <Icon name="cross" />
              </button>
            }>
            Edit Item
          </ModalHeader>
          <Form name="update-sale-balance"
            form={form} className="is-alter"
            initialValues={formData} 
            onFinish={handleEditFormSubmit}
            onFinishFailed={onFinishFailed}>
            <ModalBody>
              {errorMessage && (
                <div className="mb-3">
                  <Alert color="danger" className="alert-icon">
                    {" "}
                    <Icon name="alert-circle" /> {errorMessage}{" "}
                  </Alert>
                </div>
              )}
              <Form.Item name="damage_id" style={{ display: 'none' }}>
                <Input type="hidden" />
              </Form.Item>          
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="form-label-group">
                        <label className="form-label">Date <span className="text-danger">*</span></label>
                    </div>
                    <div className="row g-2">
                      <div className="col-7">
                        <Form.Item>
                          <Form.Item name={'date'}
                            noStyle
                            rules={[
                              {required: true, message: 'Date is required',}
                            ]}>
                            <DatePicker
                              selected={issueDate}
                              dateFormat="dd-MMM-yyyy"
                              onChange={date => {
                                // date = moment(date).format("YYYY-MM-dd");
                                setIssueDate(date);
                                form.setFieldValue({date}); // Update Ant Design Form
                              }}
                              shouldCloseOnSelect={false}
                              showMonthDropdown
                              showYearDropdown
                              isClearable
                              className="form-control form-control-lg date-picker"
                            />
                          </Form.Item>
                        </Form.Item>
                      </div>
                      <div className="col-5">
                        <Form.Item>
                          <Form.Item name={'date_time'}
                            noStyle
                            rules={[
                              {required: true, message: 'time is required',}
                            ]}>
                            <DatePicker
                              selected={issueDateTime}
                              dateFormat="h:mm aa"
                              onChange={time => {
                                // time = moment(time).format("HH:mm A");
                                setIssueDateTime(time);
                                form.setFieldValue({date_time: time}); // Update Ant Design Form
                              }}
                              shouldCloseOnSelect={false}
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={15}
                              timeCaption="Time"
                              className="form-control form-control-lg date-picker"
                            />
                          </Form.Item>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <Form.Item>
                      <div className="form-label-group">
                        <label className="form-label">Source <span className="text-danger">*</span></label>
                      </div>
                      <Form.Item name={'source_type'}
                        noStyle
                        rules={[
                          {required: true, message: 'source is required',}
                        ]}>
                        <Input size="large" disabled placeholder="Source" />
                      </Form.Item>
                    </Form.Item>
                  </div>
                </div>
                
                <div className="col-md-12">
                  <div className="form-group">
                    <Form.Item>
                      <div className="form-label-group">
                        <label className="form-label">Item Name <span className="text-danger">*</span></label>
                      </div>
                      <Form.Item name={'item_name'}
                        noStyle
                        rules={[
                          {required: true, message: 'item name is required',}
                        ]}>
                        <Input size="large" disabled placeholder="eg. Bags" />                        
                      </Form.Item>
                    </Form.Item>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                  <Form.Item>
                    <div className="form-label-group">
                      <label className="form-label">Cost Price <span className="text-danger">*</span></label>
                    </div>
                    <Form.Item name={'cost_price'}
                      noStyle
                      rules={[
                        {required: true, message: 'cost price is required'}
                      ]}>
                      <InputNumber prefix={currency} min={0} step={0.01} disabled size="large" className="w-100" /> 
                    </Form.Item> 
                  </Form.Item>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <Form.Item>
                      <div className="form-label-group">
                        <label className="form-label">Quantity <span className="text-danger">*</span></label>
                      </div>
                      <Form.Item name={'quantity'}
                        noStyle
                        rules={[
                          {required: true, message: 'quantity is required'}
                        ]}>
                        <InputNumber min={1} step={1} size="large" className="w-100" /> 
                      </Form.Item>
                    </Form.Item>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <Form.Item>
                      <div className="form-label-group">
                        <label className="form-label">Type <span className="text-danger">*</span></label>
                      </div>
                      <Form.Item name={'type'}
                        noStyle
                        rules={[
                          {required: true, message: `Select type`}
                        ]}>
                        <Select required size="large" 
                          placeholder="Select type"
                          style={{ width: "100%" }} 
                          options={[
                            {
                              key: 'damaged',
                              label: 'Damaged',
                              value: 'damaged',
                            },
                            {
                              key: 'lost',
                              label: 'Lost',
                              value: 'lost',
                            }                              
                          ]}
                          showSearch />  
                      </Form.Item> 
                    </Form.Item> 
                  </div>
                </div>
              </div>          
            </ModalBody>
            <ModalFooter className="bg-lighter justify-content-center">
              <Button disabled={requesting} onClick={handleEditFormSubmit} color="primary" size="md" className="btn-mw m-1">
                {requesting ? <Spinner size="sm" color="light" /> : "Save"}
              </Button>
              <Button disabled={requesting} color="light" size="md" className="btn-mw m-1" onClick={() => toggleModal(null)}>
                Close
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      }

      { 
        activeModal === "editSuccessModal" &&
        <SuccessModal showModal={true} toggleModal={() => toggleModal('editSuccessModal')}
          headerText={"Updated"} descriptionText={"The item has been updated successfully."} />
      }
    </Block>
  );
};
